export const WHATSAPP_NUMBER = "393453860400";
export const WHATSAPP_DISPLAY = "345 386 0400";
export const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_e79b0463-9ee4-43cc-bba9-f677ca5ecbb9/artifacts/db6vcwb9_casamore_logo_bn.png";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const VACATION_WHATSAPP = "393491057725";
export const VACATION_WHATSAPP_DISPLAY = "349 105 7725";
export const waLinkTo = (number, text) =>
  `https://wa.me/${number}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjB2aWxsYSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4NDU3MTE1OXww&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.unsplash.com/photo-1758548157126-e4c0477f796e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwbW9kZXJuJTIwbGl2aW5nJTIwcm9vbSUyMGludGVyaW9yJTIwZGF5bGlnaHR8ZW58MHx8fHwxNzg0NTcxMjI4fDA&ixlib=rb-4.1.0&q=85",
};
